<template>
    <LayoutsDefaultHeader />

    <UMain class="py-0">
        <slot />
    </UMain>

    <LayoutsDefaultFooter />

    <!--<NuxtCookieConsentPolicy />-->
</template>

<script setup>
    useBrevoWidget()
</script>
